import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;


export async function getAllVillages() {
  try {
    const response = await fetch(base + 'villages');
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getAllVillages', error);
    throw error;
  }
}

export async function getAllVillagesByRegion(r) {
  try {
    const response = await fetch(base + 'villages/r/' + r);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getAllVillages', error);
    throw error;
  }
}

export async function getVillage(v) {
  try {
    const response = await fetch(base + "villages/" + v);
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur getVillage', error);
    throw error;
  }
}
  
export async function createVillage(regionId, villageName) {
  try {
    const authToken = localStorage.getItem("authToken"); // Récupération du token
    const response = await fetch(base + 'villages/insert', {
      method: 'POST',
      credentials: "include", // Permet d'envoyer les cookies avec chaque requête, si http-only
      headers: { 'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${authToken}` // Ajout du token dans le header => penser à modifier .htaccess de l'API pour autoriser cet en-tête
       },
      body: new URLSearchParams({ nom: villageName, id_region: regionId }),
    });
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur createVillage', error);
    throw error;
  }
}

export async function updateVillage(id, villageName) {

  if(debug) console.log("id du village à modifier", id);
  if(debug) console.log("nouveau nom du village", villageName);
  try {
    const authToken = localStorage.getItem("authToken");
    const response = await fetch(base + 'villages/update', {
      method: 'POST',
      credentials: "include",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${authToken}`
      },
      body: new URLSearchParams({ id: id, nom: villageName }),
    });
    return await response.json();
  } catch (error) {
    console.error('Erreur updateVillage', error);
    throw error;
  }
}

export async function deleteVillage(id) {
  try {
    const authToken = localStorage.getItem("authToken");
    const response = await fetch(base + 'villages/delete', {
      method: 'POST',
      credentials: "include",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${authToken}`
      },
      body: new URLSearchParams({ id: id }),
    });
    return await response.json();
  } catch (error) {
    if(debug) console.error('Erreur deleteVillage', error);
    throw error;
  }
}
  